import { useRef, useState } from "react";
import { useMount } from "react-use";

const GAP_WIDTH = 14;

export type UseDropdownWidthReturn = {
  dropdownWidth: number;
  ref: React.RefObject<HTMLDivElement | null>;
};

export const useDropdownWidth = (): UseDropdownWidthReturn => {
  const ref = useRef<HTMLDivElement>(null);

  const [dropdownWidth, setDropdownWidth] = useState<number>(0);

  useMount(() => setDropdownWidth(2 * (ref.current?.offsetWidth ?? 0) + GAP_WIDTH));

  return { dropdownWidth, ref };
};
